var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"right"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"title"},[_vm._v("半年度热销单品统计")]),_c('div',{style:({ width: '90%', height: '90%' }),attrs:{"id":"myCharts"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }